"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = initiateGlobalLogHandler;
exports.deleteInstance = deleteInstance;

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _dataGathering = require("./util/dataGathering");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var instance = null;

var GlobalLogHandler = /*#__PURE__*/function () {
  function GlobalLogHandler(logger) {
    _classCallCheck(this, GlobalLogHandler);

    this.logStack = [];
    this.logger = logger;
    this.env = (0, _uigCurrentEnvironmentUtil.getCurrentEnv)();
    setInterval(this.requestNRD, this.logger.batchInterval);
  }

  _createClass(GlobalLogHandler, [{
    key: "add",
    value: function add(log) {
      instance.logStack.push(log);

      if (instance.logStack.length >= instance.logger.batchSize) {
        this.requestNRD();
      }
    }
  }, {
    key: "deleteLogs",
    value: function deleteLogs() {
      instance.logStack = [];
    }
  }, {
    key: "requestNRD",
    value: function requestNRD() {
      if (instance.logStack && instance.logStack.length > 0) {
        var url = (0, _dataGathering.getBeaconServerUrl)(instance.env);

        var logs = _toConsumableArray(instance.logStack);

        instance.logger.fetch(url, logs);
        instance.deleteLogs();
      }
    }
  }]);

  return GlobalLogHandler;
}();

function initiateGlobalLogHandler(logger) {
  if (!instance) {
    instance = new GlobalLogHandler(logger);
  }

  return instance;
}

function deleteInstance() {
  instance = null;
}